'use client';

import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import logTrailPageViewLimitReached from '@alltrails/amplitude/events/logTrailPageViewLimitReached';
import type TrailId from '@alltrails/core/types/TrailId';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';

const SignUpModal = dynamic(() => import('@alltrails/user-auth/components/SignUpModal'), { ssr: false });

type Props = {
  limitReached: boolean;
  limit: number;
  trailId: TrailId;
};

const PageViewLimit = ({ limitReached, limit, trailId }: Props) => {
  const languageRegionCode = useLanguageRegionCode();
  const [isOpen, setIsOpen] = useState(false);
  const didLoginRef = useRef(false);

  useEffect(() => {
    if (limitReached) {
      logTrailPageViewLimitReached({ limit, trail_id: trailId });
      setIsOpen(true);
    }
  }, [limitReached, limit, trailId]);

  return (
    <>
      {isOpen && (
        <SignUpModal
          trigger="Trail Details Wall 3rd Unique Viewed"
          isOpen={isOpen}
          closeModal={() => {
            if (!didLoginRef?.current) {
              window.location.assign(wrapUrlSafe(`/explore`, languageRegionCode));
            }
          }}
          deeplinkData={{ pageId: trailId, pageType: 'trail' }}
          onSuccess={() => {
            didLoginRef.current = true;
            setIsOpen(false);
          }}
          upsellTrigger="Trail Details Wall 3rd Unique Viewed"
        />
      )}
    </>
  );
};

export default PageViewLimit;
